import React from 'react'

import mobileAndTabletCheck from './../utils/mobileCheck'

import background  from './../UI/general/background.webp'
import LoadingDesktop from './desktop/loadingDesktop.Component';
import WelcomeDesktop from './desktop/welcomeScreenDesktop.Component'

import LoadingMobile from './mobile/loadingMobile.Component';
import WelcomeMobile from './mobile/welcomeScreenMobile.Component';

import Bridge from './bridge.Component'

import song from './../assets/song.mp3'
import { rejects } from 'assert';

interface Props {
    
}

interface State {
    isMobile: boolean,
    changeRotation: boolean,
    isLoading: boolean,
    showWelcome: boolean,
    show360Component: boolean,
    loadedImages: number,
    loadedAudio: number
}

interface Ingreso {
    images: any
}

class Ingreso extends React.Component<Props,State>{

    constructor(props: Props){
        super(props);
        this.state = {
            isMobile: false,
            changeRotation: false,
            isLoading: true,
            showWelcome: false,
            show360Component: false,
            loadedImages: 0,
            loadedAudio: 0
        }
    }

    componentDidMount(){
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            this.setState({isMobile: true})
        }
        else{
            this.setState({isMobile: false})
        }
        window.addEventListener('resize', this.update)


        this.images = [
            'spins/RR310/NegroRojo/1.webp',
            'spins/RR310/RojoNegro/1.webp',
            'spins/Sport100ELS/AzulPetroleoGris/1.webp',
            'spins/Sport100ELS/Gris/1.webp',
            'spins/Sport100ELS/NegroGris/1.webp',
            'spins/Sport100ELS/NegroRojo/1.webp',
            'spins/Sport100ELS/Rojo/1.webp',
            'spins/Sport100KLS/NegroRojo/1.webp',
            'spins/Sport100KLS/NegroVerde/1.webp',
            'spins/Stryker125/NegroAzul/1.webp',
            'spins/Stryker125/NegroRojo/1.webp',
            'spins/Stryker125/NegroVerde/1.webp',
            'spins/Max125/NegroAzul/1.webp',
            'spins/Max125/NegroGris/1.webp',
            'spins/Max125/NegroRojo/1.webp',
            'spins/Apache1602V/Negro/1.webp',
            'spins/Apache1602V/Gris/1.webp',
            'spins/Apache1604V/GrisAzul/1.webp',
            'spins/Apache1604V/GrisNegro/1.webp',
            'spins/Apache1604V/GrisRojo/1.webp',
            'spins/Apache1604V/RojoNegro/1.webp',
            'spins/Apache1802V/NegroRojo/1.webp',
            'spins/Apache2004V/Negro/1.webp',
            'spins/Apache2004V/NegroRojo/1.webp',
            'spins/200FI/AzulNegro/1.webp',
            'spins/200FI/RojoNegro/1.webp',
            'spins/Raider/Amarillo/1.webp',
            'spins/Raider/Azul/1.webp',
            'spins/Raider/Negro/1.webp',
            'spins/Raider/Rojo/1.webp',
            'spins/Ntorq125/AzulBlancoNegro/1.webp',
            'spins/Ntorq125/BlancoRojoNegro/1.webp',
            'spins/Ntorq125/NegroAmarillo/1.webp',
            'spins/Ntorq125/NegroGris/1.webp',
            'spins/Ntorq125/NegroRojo/1.webp',
            'spins/Ntorq125Racing/NegroRojo/1.webp',
            'spins/Ntorq125FI/NegroVerde/1.webp',
            'spins/NeoNX110/GrisAzul/1.webp',
            'spins/NeoNX110/NegroRojo/1.webp',
            'spins/NeoNX110/NegroVerde/1.webp',
            'spins/MotoCarroGS/BlancoRojoNegro/1.webp',
            'spins/MotoCarroGSEspecial/BlancoRojoNegro/1.webp',
            'spins/MotoCarroGSFull/BlancoRojoNegro/1.webp',

            require('./../assets/panoramas/General_01.webp').default,
            require('./../assets/panoramas/General_02.webp').default,
            require('./../assets/panoramas/Max125_Frente.webp').default,
            require('./../assets/panoramas/RR310_Frente.webp').default,
            require('./../assets/panoramas/Stryker_Frente.webp').default,
            require('./../assets/panoramas/RTR200FI_Frente.webp').default,
            require('./../assets/panoramas/MTbasico_Frente.webp').default,
            require('./../assets/panoramas/NeoNX110_Frente.webp').default,
            require('./../assets/panoramas/Ntorq125_Frente.webp').default,
            require('./../assets/panoramas/RTR1602V_Frente.webp').default,
            require('./../assets/panoramas/RTR1604V_Frente.webp').default,
            require('./../assets/panoramas/RTR1802V_Frente.webp').default,
            require('./../assets/panoramas/RTR2004V_Frente.webp').default,
            require('./../assets/panoramas/SportELS_Frente.webp').default,
            require('./../assets/panoramas/SportKLS_Frente.webp').default,
            require('./../assets/panoramas/TVSraider_Frente.webp').default,
            require('./../assets/panoramas/Ntorq125FI_Frente.webp').default,
            require('./../assets/panoramas/MTcarpaFull_Frente.webp').default,
            require('./../assets/panoramas/Ntorq125Racing_Frente.webp').default,
            require('./../assets/panoramas/MTcarpaEspecial_Frente.webp').default,
            require('./../assets/panoramas/Ntorq125Familia.webp').default,
            require('./../assets/panoramas/TVSsportFamilia.webp').default,
            require('./../assets/panoramas/TVSapacheFamilia.webp').default,
            require('./../assets/panoramas/TVSmotocarroFamilia.webp').default,

            require('./../assets/panoramasMobile/General_01.webp').default,
            require('./../assets/panoramasMobile/General_02.webp').default,
            require('./../assets/panoramasMobile/Max125_Frente.webp').default,
            require('./../assets/panoramasMobile/RR310_Frente.webp').default,
            require('./../assets/panoramasMobile/Stryker_Frente.webp').default,
            require('./../assets/panoramasMobile/RTR200FI_Frente.webp').default,
            require('./../assets/panoramasMobile/MTbasico_Frente.webp').default,
            require('./../assets/panoramasMobile/NeoNX110_Frente.webp').default,
            require('./../assets/panoramasMobile/Ntorq125_Frente.webp').default,
            require('./../assets/panoramasMobile/RTR1602V_Frente.webp').default,
            require('./../assets/panoramasMobile/RTR1604V_Frente.webp').default,
            require('./../assets/panoramasMobile/RTR1802V_Frente.webp').default,
            require('./../assets/panoramasMobile/RTR2004V_Frente.webp').default,
            require('./../assets/panoramasMobile/SportELS_Frente.webp').default,
            require('./../assets/panoramasMobile/SportKLS_Frente.webp').default,
            require('./../assets/panoramasMobile/TVSraider_Frente.webp').default,
            require('./../assets/panoramasMobile/Ntorq125FI_Frente.webp').default,
            require('./../assets/panoramasMobile/MTcarpaFull_Frente.webp').default,
            require('./../assets/panoramasMobile/Ntorq125Racing_Frente.webp').default,
            require('./../assets/panoramasMobile/MTcarpaEspecial_Frente.webp').default,
            require('./../assets/panoramasMobile/Ntorq125Familia.webp').default,
            require('./../assets/panoramasMobile/TVSsportFamilia.webp').default,
            require('./../assets/panoramasMobile/TVSapacheFamilia.webp').default,
            require('./../assets/panoramasMobile/TVSmotocarroFamilia.webp').default,
            
        ]

        this.images.forEach((src: any)=> {
            new Promise((resolve, reject) => {
                const img = new Image()
                img.src = src
                img.onload = (event) => {
                    this.setState({
                        loadedImages: this.state.loadedImages + 1
                    }, () => {
                        if(this.state.loadedImages === this.images.length){
                            this.handleHideLoadingScreen()
                        }
                    })
                }
            })
        });

        new Promise((resolve, reject) => {
            const audio = new Audio()
            audio.src = song
            audio.addEventListener("canplaythrough", () => {
                this.setState({
                    loadedAudio: this.state.loadedAudio + 1
                }, () => {
                    
                })
            })
        })
    }

    update = () => {
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            this.setState({isMobile: true, changeRotation: true})
        }
        else{
            this.setState({isMobile: false, changeRotation: true})
        }
    }

    handleHideLoadingScreen = () => {
        this.setState({
            showWelcome: true,
            isLoading: false,
        })
    }

    handleHideInfoScreen = () => {
        this.setState({
            show360Component: true
        })
    }

    render(){
        return(
            <div className='main-page'>
                <div className='main-background'>
                    <img src={background}  alt=""  className='background-image'/>
                </div>
                {
                    this.state.isMobile ? 
                    <React.Fragment>
                        {/*Mobile Loading Screen*/}
                        <LoadingMobile
                            isLoading={this.state.isLoading}
                        />
                        {/*Welcome Screen Mobile*/
                            this.state.showWelcome ?
                            <WelcomeMobile 
                                handleHideInfoScreen={this.handleHideInfoScreen}
                                rotationChanged={this.state.changeRotation}
                                isLoading={this.state.isLoading}
                            />:null
                        }
                        {
                            this.state.show360Component ?
                            <Bridge 
                                isMobile = {this.state.isMobile}
                            />:null
                        }
                    </React.Fragment>:
                    <React.Fragment>
                        {/*Desktop Loading Screen*/}
                        <LoadingDesktop
                            isLoading={this.state.isLoading}
                        />
                        {/*Welcome Screen*/ 
                            this.state.showWelcome ?
                            <WelcomeDesktop
                                handleHideInfoScreen={this.handleHideInfoScreen}
                                rotationChanged={this.state.changeRotation}
                                isLoading={this.state.isLoading}
                            />:null
                        }
                        {
                            this.state.show360Component ?
                            <Bridge 
                                isMobile = {this.state.isMobile}
                            />:null
                        }
                    </React.Fragment>
                }
            </div>
        )
    }

} 

export default Ingreso